import TextNode from '../../model/TextNode'

class ListItem extends TextNode {}

ListItem.type = 'list-item'

export default ListItem
